// extracted by mini-css-extract-plugin
export default {"chatContainer":"Chat_chatContainer__v5enF"};